const locations = [
  {
    index: 0,
    name: "Eventyrbrua",
    info: "Trykk på knappen mens du står på eventyrbrua for å få første clue!",
    image: "/Kongeship.jpg",
    coordinates: {
      northWest: { lat: 59.9185, lon: 10.7557 },
      southEast: { lat: 59.9179, lon: 10.7565 },
    },
  },
  {
    index: 1,
    name: "OsloSlott",
    info: "Du skal til et sted som har hatt minst tre adresser. En person som bor her har en oljeplattform oppkalt etter seg. Let them eat cake!",
    image: "/Crocus.jpg",
    coordinates: {
      northWest: { lat: 59.9184, lon: 10.7259 },
      southEast: { lat: 59.9157, lon: 10.7301 },
    },
  },
  {
    index: 2,
    name: "FragranceOf the Heart",
    info: "Du skal få lov å ta deg en Kaffee først! Her hadde en bestemmt Indisk Guru også gjerne slått seg ned. Han du ser på bildet har blant annet opphøyet en som kjempet i ringen og en som kjempet for frihet! Pass på å IKKE havne for nært ved havet!",
    image: "/sri-chinmoy.jpg",
    coordinates: {
      northWest: { lat: 59.9276, lon: 10.7155 },
      southEast: { lat: 59.9272, lon: 10.7164 },
    },
  },
  {
    index: 3,
    name: "Frognerpark",
    info: "Du skal se nakene mennesker. Men dem er ikke levende...",
    image: "/Baby.jpg",
    coordinates: {
      northWest: { lat: 59.9351, lon: 10.6812 },
      southEast: { lat: 59.9218, lon: 10.7137 },
    },
  },
  {
    index: 4,
    name: "Damplassen",
    info: "En svensk fiskedamm er ikke på monopolbrettet, men stedet hvor den ligger har sitt eget felt.",
    image: "/Pizza.jpg",
    coordinates: {
      northWest: { lat: 59.9438, lon: 10.7329 },
      southEast: { lat: 59.9432, lon: 10.7343 },
    },
  },
  {
    index: 5,
    name: "EvaldRyghsPlass",
    info: "Du skal til et sted, hvor du kan både spille ballspill, leke og minnes en trøndersk ordfører som var glad i penger og kultur. Men hvis du vil hoppe så er du på villspor.",
    image: "/EvaldRygh.jpg",
    coordinates: {
      northWest: { lat: 59.9295, lon: 10.7469 },
      southEast: { lat: 59.9287, lon: 10.7486 },
    },
  },
  {
    index: 6,
    name: "LofthusTranen",
    info: "Nå kan du nesten se oss vinke fra målet. Dette her (uten Leber) må du drikke hvis du har tapt Stocherkahn løpet i Tuebingen. Nipaporn Norse har vært her.",
    image: "/Stocherkahn.jpg",
    coordinates: {
      northWest: { lat: 59.9283, lon: 10.7484 },
      southEast: { lat: 59.9279, lon: 10.7495 },
    },
  },
  {
    index: 7,
    name: "Mål",
    info: "Hurra! Du klarte det! Du er så flink, flink, flink, flink, flink. Velkommen in!",
    image: "/Hurra.jpg",
    coordinates: {
      northWest: { lat: 59.9283, lon: 10.7485 },
      southEast: { lat: 59.9279, lon: 10.7495 },
    },
  },
];

export default locations;
